import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./features/auth/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/forgot-password.component').then(m => m.ForgotPasswordComponent),
  },
  {
    path: 'accept-invite',
    loadComponent: () =>
      import('./features/auth/accept-invite.component').then(m => m.AcceptInviteComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shell/shell.component').then(m => m.ShellComponent),
    children: [
      { path: '', redirectTo: 'students', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            m => m.DashboardComponent
          ),
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./features/students/list/student-list.component').then(
            m => m.StudentListComponent
          ),
      },
      {
        path: 'students/new',
        canActivate: [roleGuard],
        data: { roles: ['Directivo', 'Administrativo'] },
        loadComponent: () =>
          import('./features/students/edit/student-edit.component').then(
            m => m.StudentEditComponent
          ),
      },
      {
        path: 'students/:id',
        data: { mode: 'detail' },
        loadComponent: () =>
          import('./features/students/edit/student-edit.component').then(
            m => m.StudentEditComponent
          ),
      },
      {
        path: 'students/:id/edit',
        canActivate: [roleGuard],
        data: { roles: ['Directivo', 'Administrativo'] },
        loadComponent: () =>
          import('./features/students/edit/student-edit.component').then(
            m => m.StudentEditComponent
          ),
      },
      {
        path: 'staff',
        loadComponent: () =>
          import('./features/staff/list/staff-list.component').then(
            m => m.StaffListComponent
          ),
      },
      {
        path: 'staff/new',
        canActivate: [roleGuard],
        data: { roles: ['Directivo', 'Administrativo'] },
        loadComponent: () =>
          import('./features/staff/new/staff-new.component').then(
            m => m.StaffNewComponent
          ),
      },
      {
        path: 'staff/:id',
        data: { mode: 'detail' },
        loadComponent: () =>
          import('./features/staff/new/staff-new.component').then(
            m => m.StaffNewComponent
          ),
      },
      {
        path: 'staff/:id/edit',
        canActivate: [roleGuard],
        data: { mode: 'edit', roles: ['Directivo', 'Administrativo'] },
        loadComponent: () =>
          import('./features/staff/new/staff-new.component').then(
            m => m.StaffNewComponent
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./features/profile/profile.component').then(
            m => m.ProfileComponent
          ),
      },
      {
        path: 'deleted',
        canActivate: [roleGuard],
        data: { roles: ['Directivo', 'Administrativo'] },
        loadComponent: () =>
          import('./features/deleted/deleted.component').then(m => m.DeletedComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
